import { dashboardEn } from './dashboard-en.ts';
import { dashboardUzLatn, type DashboardCatalog } from './dashboard-uz-latn.ts';

/** Locales the dashboard has a complete catalog for (Russian is added the same way, PLANNED). */
export type DashboardLocale = 'uz-Latn' | 'en';

export const DASHBOARD_CATALOGS: Readonly<Record<DashboardLocale, DashboardCatalog>> = {
  'uz-Latn': dashboardUzLatn,
  en: dashboardEn,
};

/** The catalog for a user's preferred locale; anything without a catalog yet gets Uzbek. */
export function dashboardCatalogFor(locale: string): DashboardCatalog {
  return locale === 'en' ? dashboardEn : dashboardUzLatn;
}
